<template>
  <div class="modal fade" id="modalConfirmarCancelacionQueja" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Confirmar Cancelación de Queja Administrativa</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <br />
          <div class="row new-row">
            <div class="col-12">
              <h5>Razón:</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <input type="text" class="form-control" v-model="razonCancelacion" />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button"
                  class="btn btn-primary"
                  data-dismiss="modal"
                  @click="cancelarQueja" :disabled="deshabilitarBotonCancelarQueja">
            Aceptar
          </button>
          <button type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal">
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';
  import catalogos from '@/../static/js/catalogos'
  import store from '@/store/index'

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        catalogos,
        razonCancelacion: ""
      }
    },
    props: {
      quejaAdministrativaId: Number,
    },
    mounted() {

    },
    components: {
    },
    methods: {
      cancelarQueja: function () { //Retorna una lista de citas 'Aceptadas'
        var peticion = {
          "esPrueba": false,
          "quejaAdministrativaId": this.quejaAdministrativaId,
          "razonCancelacion": this.razonCancelacion
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIQA.funciones.CancelarQuejaAdministrativa, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          comun.SeEstaCargandoInformacion(true);
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.$emit("valorParaElPadre", this.quejaAdministrativaId);
            comun.mensajeDeAlerta(response.data.Satisfactorio)
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          comun.SeEstaCargandoInformacion(false);
        });
      },
      
    },
    created() {

    }, computed: {
      deshabilitarBotonCancelarQueja: function () {
        return !this.razonCancelacion || this.razonCancelacion.length < 5
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SIQA/QuejasAdministrativas/ReporteQuejasAdministrativas/ModalConfirmarCancelacionQueja.vue